import { createGlobalStyle } from "styled-components"
import media from "cssMix/index"

export default createGlobalStyle`
 html,
body,
#root{
    font-family:  "Segoe UI",Roboto,"Helvetica Neue", Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" ;
    width:100%;
    height: 100%;
    border: 0;
    padding: 0;
    margin: 0;
    -webkit-overflow-scrolling: unset;
    
}
#root{
    overflow:hidden;
    ${media.tablet`
    overflow-y:overlay;
    `}
}


a{
    text-decoration: none;
}
input{
  padding:0;
  margin:0;
  border-width:0;
  outline: none;
  -webkit-appearance: none;
   ::-webkit-input-placeholder{
    -webkit-text-stroke: none;
  }
}
button {
        padding:0;
        border:0;
        background:transparent;
        outline:none;
      }
::-webkit-scrollbar {
    -webkit-appearance: none;
    background-color: rgba(0,0,0,0);
    width: 7px;
    height:7px;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,0);
}
  `
